import React, { useEffect, useState } from 'react';
import classes from "./SelectPacksPage.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Header from '../../components/Header';
import { SendOtpAPI } from '../../http/http';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';

// const PACKS = [
//     {
//         id: "daily",
//         name: "Forfait journalier",
//         description: "Renouvellement automatique chaque jour",
//         price: "50 F",
//         period: "/ jour",
//         popular: true,
//     },
//     {
//         id: "weekly",
//         name: "Forfait hebdomadaire",
//         description: "Renouvellement automatique chaque semaine",
//         price: "250 F",
//         period: "/ semaine",
//         popular: false,
//     },
// ];

const CheckIcon = () => (
    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
        <path
            d="M5 12.5l4.2 4.2L19 7"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const SelectPacksPage = () => {

    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedPack, setSelectedPack] = useState("daily");
    const [extRef, setExtRef] = useState(null);
    const location = useLocation();
    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setSelectedPack(location?.state?.pack);
        }
        else {
            // navigate("/");
        }
    }, [location]);

    const handleContinue = async () => {
        if (loading) return;
        try {

            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);
            await SendOtpAPI(msisdn);
            setLoading(false);

            navigate('/promo/otp', {
                state: {
                    msisdn,
                    extRef,
                    pack: selectedPack,
                }
            });

        }
        catch (error) {
            toast.error(t("88"))
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />

            <div className={classes.page}>
                <img
                    src="/assets/images/select-packs.png"
                    alt=""
                    className={classes.hero}
                    draggable={false}
                />

                <div className={classes.card}>

                    <div className={classes.header_section}>
                        <div className={classes.back_button} onClick={() => {
                            navigate("/promo/auth");
                        }}>
                            <FaArrowLeft className={classes.back_icon} />
                        </div>

                    </div>


                    <h1 className={classes.title_main}>
                        {t("177")}
                    </h1>

                    <p className={classes.title_sub}>
                        {t("178")}
                    </p>

                    <div
                        className={classes.packs}
                        role="radiogroup"
                        aria-label="Choisissez votre forfait"
                    >


                        <label
                            className={`${classes.pack} ${selectedPack === 'daily' ? classes.pack_selected : ""}`}
                        >
                            <input
                                type="radio"
                                name="pack"
                                value={'daily'}
                                checked={selectedPack === 'daily'}
                                onChange={() => setSelectedPack('daily')}
                                className={classes.radio_input}
                            />

                            <span className={classes.radio} aria-hidden="true">
                                {selectedPack === 'daily' && <CheckIcon />}
                            </span>

                            <span className={classes.pack_info}>
                                <span className={classes.pack_name_row}>
                                    <span className={classes.pack_name}>{t("171")}</span>
                                    {/* {pack.popular && (
                                        <span className={classes.badge}>Populaire</span>
                                    )} */}
                                </span>
                                <span className={classes.pack_desc}>{t("172")}</span>
                            </span>

                            <span className={classes.pack_price}>
                                <span className={classes.price}>{"50 F"}</span>
                                <span className={classes.period}>{t("173")}</span>
                            </span>
                        </label>

                        <label
                            className={`${classes.pack} ${selectedPack === 'weekly' ? classes.pack_selected : ""}`}
                        >
                            <input
                                type="radio"
                                name="pack"
                                value={'weekly'}
                                checked={selectedPack === 'weekly'}
                                onChange={() => setSelectedPack('weekly')}
                                className={classes.radio_input}
                            />

                            <span className={classes.radio} aria-hidden="true">
                                {selectedPack === 'weekly' && <CheckIcon />}
                            </span>

                            <span className={classes.pack_info}>
                                <span className={classes.pack_name_row}>
                                    <span className={classes.pack_name}>{t("174")}</span>
                                    {/* {pack.popular && (
                                        <span className={classes.badge}>Populaire</span>
                                    )} */}
                                </span>
                                <span className={classes.pack_desc}>{t("175")}</span>
                            </span>

                            <span className={classes.pack_price}>
                                <span className={classes.price}>{"250 F"}</span>
                                <span className={classes.period}>{t("176")}</span>
                            </span>
                        </label>
                    
                    </div>

                
                </div>

                <div className={classes.cta_bar}>
                    <button
                        type="button"
                        className={classes.cta}
                        onClick={handleContinue}
                        disabled={loading}
                    >
                        {loading ? <span className={classes.spinner} aria-label="Chargement" /> : t("170")}
                    </button>
                </div>
            </div>
        </>
    )
}

export default SelectPacksPage